module.exports = require("./../../_gen/starling/textures/TextureOptions");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/textures/TextureOptions.js
// module id = 239
// module chunks = 0